<template>
  <div>
    <v-form ref="form">
      <v-row class="ma-0">
        <v-col cols="12" class="py-0">
          <strong>Selecione os campos comuns</strong>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Unidade') && category == 1"
        >
          <label class="ml-1 text-caption"> {{ $t('Unidade') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="data.unidadeId"
            :rules="[(v) => !!v || 'Selecione a unidade']"
            @change="getDepartments(data.unidadeId)"
            :items="unidades"
            item-text="name"
            item-value="id"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Unidade')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Setor') && category == 1"
        >
          <label class="ml-1 text-caption"> {{ $t('Setor') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            :disabled="!data.unidadeId"
            v-model="data.departmentId"
            :rules="[(v) => !!v || 'Selecione o setor']"
            :items="departments"
            item-text="name"
            item-value="id"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Setor')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Localização') && category == 1"
        >
          <label class="ml-1 text-caption"> {{ $t('Localização') }} </label>
          <v-text-field
            v-model="data.location"
            :rules="[(v) => !!v || 'Digite a localização']"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Localização')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Identificação') && category == 0"
        >
          <label class="ml-1 text-caption"> {{ $t('Identificação') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="data.equipmentId"
            :rules="[(v) => !!v || 'Selecione o equipamento']"
            item-text="identification"
            :items="equipments"
            item-value="id"
            outlined
            style="min-width: 200px"
            class="ma-1 primary-input"
            hide-details="auto"
            placeholder="Identificação"
            value="Identificação"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
            <template v-slot:item="{ item }">
              <span class="text-caption">
                {{ item.identification }} / {{ item.name }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Nome O.S.')"
        >
          <label class="ml-1 text-caption"> {{ $t('Nome O.S.') }} </label>
          <v-text-field
            v-model="data.name"
            :rules="[(v) => !!v || 'Digite o nome para a O.S.']"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Nome O.S.')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Tipo O.S.')"
        >
          <label class="ml-1 text-caption"> Tipo O.S. </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="data.serviceOrderType"
            :item-text="(item) => $t(item.text)"
            item-value="value"
            :rules="[(v) => v != null || 'Selecione o Tipo da O.S.']"
            outlined
            class="primary-input"
            :items="types"
            hide-details="auto"
            :placeholder="$t('Tipo O.S.')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Responsável')"
        >
          <label class="ml-1 text-caption"> {{ $t('Responsável') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="data.responsibleName"
            :rules="[(v) => !!v || 'Selecione o responsável']"
            item-text="name"
            item-value="name"
            :items="users"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Responsável')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Solicitante')"
        >
          <label class="ml-1 text-caption"> {{ $t('Solicitante') }} </label>
          <v-text-field
            v-model="data.requester"
            :rules="[(v) => !!v || 'Digite o Solicitante']"
            outlined
            class="primary-input"
            hide-details="auto"
            placeholder="Solicitante"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Data e hora de solicitação')"
        >
          <label class="ml-1 text-caption">
            {{ $t('Data de solicitação') }}
          </label>

          <v-menu
            ref="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                :rules="[(v) => !!v || 'Selecione a data de solicitação']"
                class="primary-input"
                :value="formatDate(data.dateTimeRequest)"
                :placeholder="$t('Data e hora de solicitação')"
                prepend-inner-icon="mdi-calendar"
                readonly
                hide-details="auto"
                v-bind="attrs"
                v-on="on"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="data.dateTimeRequest"
              scrollable
              locale="pt-Br"
            >
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes('Solicitação / Reclamação')"
        >
          <label class="ml-1 text-caption">
            {{ $t('Solicitação / Reclamação') }}
          </label>
          <v-text-field
            v-model="data.request"
            :rules="[(v) => !!v || 'Digite a Solicitação / Reclamação']"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Solicitação / Reclamação')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="
            selectedFields.includes('Oficina') &&
            institution.departmentTypes.includes(1)
          "
        >
          <label class="ml-1 text-caption"> {{ $t('Oficina') }} </label>
          <v-autocomplete
            v-model="data.workshopId"
            :items="workshopTypes"
            item-text="name"
            item-value="id"
            autocomplete="off"
            :rules="[(v) => v != null || 'Oficina obrigatório']"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Oficina')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex justify-end">
      <v-btn text @click="$emit('back')"> {{ $t('Voltar') }} </v-btn>
      <v-btn color="primary mr-0" elevation="0" @click="confirm">
        {{ $t('Continue') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../../../services/ApiService'

export default {
  name: 'CommomFieldsStep',

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.getWorkshops()
  },

  props: {
    selectedFields: Array,
    category: Number,
    users: Array,
    equipments: Array,
    types: Array,
    unidades: Array,
  },

  data: () => ({
    institution: {},
    data: {
      departmentId: null,
      location: '',
      equipmentId: null,
      name: '',
      requester: '',
      serviceOrderType: '',
      responsibleName: '',
      dateTimeRequest: '',
      request: '',
    },
    workshopTypes: [
      { text: 'Carpintaria', value: 0 },
      { text: 'Elétrica', value: 2 },
      { text: 'Hidráulica', value: 3 },
      { text: 'Climatização', value: 4 },
      { text: 'Gasoterapia', value: 5 },
      { text: 'Zeladoria', value: 6 },
      { text: 'Vidraçaria', value: 7 },
      { text: 'Mecânica', value: 8 },
      { text: 'Serralheria', value: 9 },
      { text: 'Predial Civil', value: 10 },
      { text: 'Pintura Predial', value: 11 },
      { text: 'Pintura Industrial', value: 12 },
    ],
    apiService: new ApiService(),
    departments: [],
  }),

  methods: {
    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    async getDepartments(id) {
      await this.apiService
        .get(`department/list/unidade/${id}`, true, false)
        .then((response) => {
          this.departments = response.content
        })
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : ''
    },

    confirm() {
      if (this.$refs.form.validate()) {
        this.$emit('confirm', this.data)
      }
    },
  },
}
</script>

<style>
.vc-popover-content-wrapper {
  z-index: 100;
}
.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}
</style>
